export enum PspContractStatus {
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  CONTRACT_CREATED = 'CONTRACT_CREATED',
  ACTIVE = 'ACTIVE',
  FAILED = 'FAILED',
}
